import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
import React, { useContext, useEffect, useState } from 'react';
import { View, Text, TouchableOpacity, Linking } from 'react-native';
import { cdnFile } from '@mkt-common/shopee-common';
import { useLocale } from '../../LocaleProvider/rn';
import { Button } from '../../Button/rn';
import { Popup } from '../../Popup/rn';
import Copy from '../../../assets/images/rn/CopyV2';
import Phone from '../../../assets/images/rn/PhoneV2';
import Email from '../../../assets/images/rn/EmailV2';
import Whatsapp from '../../../assets/images/rn/Whatsapp';
import Facebook from '../../../assets/images/rn/Facebook';
import Line from '../../../assets/images/rn/Line';
import More from '../../../assets/images/rn/More';
import PhoneBlack from '../../../assets/images/rn/PhoneBlack';
import EmailBlack from '../../../assets/images/rn/EmailBlack';
import WhatsappBlack from '../../../assets/images/rn/WhatsappBlack';
import FacebookBlack from '../../../assets/images/rn/FacebookBlack';
import LineBlack from '../../../assets/images/rn/LineBlack';
import { ConfigContext, dataMaintainer } from '../../ConfigProvider/rn/context';
import { ButtonEvents } from '../../../types';
import { CONTACT_COURIER_CARD } from '../../../utils/constants';
import { Image } from '../../Image/rn';
import { getRealPx } from '../../../utils/rn/tools';
import { replaceParams } from '../../../utils/tools';
import { TRACKING_OPERATION } from '../../../utils/tracking/constants';
import { emitTrackingEvent } from '../../../hooks/rn/useTracking';
import { ActInternalType } from '../../ContactCourierCard/rn';
import styles from './styles';
var CONTACT_COURIER_CARD_V2_SCOPE = 'CONTACT_COURIER_CARD_V2_SCOPE';
export var ContactInfoEnum;
(function (ContactInfoEnum) {
  ContactInfoEnum["Email"] = "email";
  ContactInfoEnum["WhatsApp"] = "whatsapp";
  ContactInfoEnum["Facebook"] = "facebook";
  ContactInfoEnum["Call"] = "call";
  ContactInfoEnum["Line"] = "line";
  ContactInfoEnum["CallDriver"] = "call_driver";
})(ContactInfoEnum || (ContactInfoEnum = {}));
export var ContactCourierCard = function ContactCourierCard(props) {
  var _webformButton$action, _operateTime$map, _driverInfo$milestone;
  var trackLinks = props.trackLinks,
    _props$contactsInfo = props.contactsInfo,
    contactsInfo = _props$contactsInfo === void 0 ? [] : _props$contactsInfo,
    _props$driverInfo = props.driverInfo,
    driverInfo = _props$driverInfo === void 0 ? {} : _props$driverInfo,
    courierTitle = props.courierTitle,
    orderInfo = props.orderInfo,
    operateTime = props.operateTime,
    handleCopyClick = props.handleCopyClick,
    showDriverInfo = props.showDriverInfo,
    webformButton = props.webformButton,
    onWebformButtonClick = props.onWebformButtonClick,
    _props$componentTrack = props.componentTrackingData,
    componentTrackingData = _props$componentTrack === void 0 ? {} : _props$componentTrack,
    isHistory = props.isHistory;
  var _componentTrackingDat = componentTrackingData.button,
    button = _componentTrackingDat === void 0 ? {} : _componentTrackingDat,
    _componentTrackingDat2 = componentTrackingData.contactButton,
    contactButton = _componentTrackingDat2 === void 0 ? {} : _componentTrackingDat2,
    _componentTrackingDat3 = componentTrackingData.popupButton,
    popupButton = _componentTrackingDat3 === void 0 ? {} : _componentTrackingDat3;
  var _useLocale = useLocale(),
    trans = _useLocale.trans,
    region = _useLocale.region;
  var context = useContext(ConfigContext);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isLinkPopUpActive = _useState2[0],
    setIsLinkPopUpActive = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isContactPopupActive = _useState4[0],
    setIsContactPopupActive = _useState4[1];
  var showWebformButton = (webformButton === null || webformButton === void 0 ? void 0 : webformButton.button_text) && ((_webformButton$action = webformButton.action) === null || _webformButton$action === void 0 ? void 0 : _webformButton$action.formstack);
  var trackButtonText = trans(CONTACT_COURIER_CARD.TRACK_ORDER);
  var trackButtonTrackingData = _objectSpread(_objectSpread({}, button.trackingdataBasic), {}, {
    button_text: trackButtonText,
    button_type: 'track_order'
  });
  var expediteButtonTrackingData = showWebformButton ? _objectSpread(_objectSpread({}, button.trackingdataBasic), {}, {
    button_text: webformButton.button_text,
    button_type: 'expedite_delivery'
  }) : null;
  var operateTimeText = (operateTime === null || operateTime === void 0 ? void 0 : (_operateTime$map = operateTime.map(function (v) {
    var _v$working_day, _v$working_day2, _v$working_day3, _v$working_hour, _v$working_hour2;
    return "".concat(v === null || v === void 0 ? void 0 : (_v$working_day = v.working_day) === null || _v$working_day === void 0 ? void 0 : _v$working_day.start, " ").concat(v !== null && v !== void 0 && (_v$working_day2 = v.working_day) !== null && _v$working_day2 !== void 0 && _v$working_day2.end ? '- ' + (v === null || v === void 0 ? void 0 : (_v$working_day3 = v.working_day) === null || _v$working_day3 === void 0 ? void 0 : _v$working_day3.end) : '', " (").concat(v === null || v === void 0 ? void 0 : (_v$working_hour = v.working_hour) === null || _v$working_hour === void 0 ? void 0 : _v$working_hour.start, " - ").concat(v === null || v === void 0 ? void 0 : (_v$working_hour2 = v.working_hour) === null || _v$working_hour2 === void 0 ? void 0 : _v$working_hour2.end, ")");
  })) === null || _operateTime$map === void 0 ? void 0 : _operateTime$map.join(', ')) || '';
  var handleTrack = function handleTrack() {
    var _dataMaintainer$track, _dataMaintainer$track2;
    if ((trackLinks === null || trackLinks === void 0 ? void 0 : trackLinks.length) === 1) {
      var _context$eventEmitter, _context$eventEmitter2, _trackLinks$;
      context === null || context === void 0 ? void 0 : (_context$eventEmitter = context.eventEmitter) === null || _context$eventEmitter === void 0 ? void 0 : (_context$eventEmitter2 = _context$eventEmitter.emit) === null || _context$eventEmitter2 === void 0 ? void 0 : _context$eventEmitter2.call(_context$eventEmitter, ButtonEvents.Redirection, {
        text: '',
        action: {
          url_info: {
            url: trackLinks === null || trackLinks === void 0 ? void 0 : (_trackLinks$ = trackLinks[0]) === null || _trackLinks$ === void 0 ? void 0 : _trackLinks$.url
          }
        }
      });
    } else {
      setIsLinkPopUpActive(true);
    }
    (_dataMaintainer$track = dataMaintainer.tracker) === null || _dataMaintainer$track === void 0 ? void 0 : (_dataMaintainer$track2 = _dataMaintainer$track.dispatchTrack) === null || _dataMaintainer$track2 === void 0 ? void 0 : _dataMaintainer$track2.call(_dataMaintainer$track, {
      operation: TRACKING_OPERATION.CLICK,
      section: button.trackingsection,
      target: button.trackingtarget,
      data: trackButtonTrackingData
    });
  };
  var contactButtons = contactsInfo === null || contactsInfo === void 0 ? void 0 : contactsInfo.map(function (item) {
    return _objectSpread({}, item);
  });
  var showDriverCallButton = showDriverInfo && (driverInfo === null || driverInfo === void 0 ? void 0 : driverInfo.driver_phone);
  var firstButton = showDriverCallButton ? {
    action: ContactInfoEnum.CallDriver,
    information: driverInfo.driver_phone
  } : contactButtons.shift();
  var restButtons = showDriverCallButton ? [firstButton].concat(contactButtons) : contactButtons;
  var renderContactButton = function renderContactButton(buttonInfo, isFirst) {
    var isCallOrEmail = [ContactInfoEnum.CallDriver, ContactInfoEnum.Call, ContactInfoEnum.Email].includes(buttonInfo.action);
    var handleInternetCall = function handleInternetCall(other) {
      if ((buttonInfo === null || buttonInfo === void 0 ? void 0 : buttonInfo.act_internal_type) === ActInternalType.InternetCall) {
        var data = buttonInfo !== null && buttonInfo !== void 0 ? buttonInfo : {};
        if (data !== null && data !== void 0 && data.inhouse_queue_call) {
          var _context$eventEmitter3, _context$eventEmitter4;
          context === null || context === void 0 ? void 0 : (_context$eventEmitter3 = context.eventEmitter) === null || _context$eventEmitter3 === void 0 ? void 0 : (_context$eventEmitter4 = _context$eventEmitter3.emit) === null || _context$eventEmitter4 === void 0 ? void 0 : _context$eventEmitter4.call(_context$eventEmitter3, ButtonEvents.InternetCall, {
            text: '',
            data: data === null || data === void 0 ? void 0 : data.inhouse_queue_call
          });
        } else {
          var _context$eventEmitter5, _context$eventEmitter6;
          context === null || context === void 0 ? void 0 : (_context$eventEmitter5 = context.eventEmitter) === null || _context$eventEmitter5 === void 0 ? void 0 : (_context$eventEmitter6 = _context$eventEmitter5.emit) === null || _context$eventEmitter6 === void 0 ? void 0 : _context$eventEmitter6.call(_context$eventEmitter5, ButtonEvents.NoQueueInternetCall, {
            text: ''
          });
          setIsContactPopupActive(false);
        }
      } else {
        other === null || other === void 0 ? void 0 : other();
      }
    };
    if (isFirst) {
      var _ContactInfoEnum$Call;
      var icon = (_ContactInfoEnum$Call = {}, _defineProperty(_ContactInfoEnum$Call, ContactInfoEnum.CallDriver, /*#__PURE__*/React.createElement(TouchableOpacity, {
        onPress: function onPress() {
          Linking.openURL("tel:".concat(buttonInfo.information));
        }
      }, /*#__PURE__*/React.createElement(Phone, null))), _defineProperty(_ContactInfoEnum$Call, ContactInfoEnum.Call, /*#__PURE__*/React.createElement(TouchableOpacity, {
        onPress: function onPress() {
          handleInternetCall(function () {
            Linking.openURL("tel:".concat(buttonInfo.information));
          });
        }
      }, /*#__PURE__*/React.createElement(Phone, null))), _defineProperty(_ContactInfoEnum$Call, ContactInfoEnum.Email, /*#__PURE__*/React.createElement(TouchableOpacity, {
        onPress: function onPress() {
          Linking.openURL("mailto:".concat(buttonInfo.information));
        }
      }, /*#__PURE__*/React.createElement(Email, null))), _defineProperty(_ContactInfoEnum$Call, ContactInfoEnum.WhatsApp, /*#__PURE__*/React.createElement(Whatsapp, null)), _defineProperty(_ContactInfoEnum$Call, ContactInfoEnum.Facebook, /*#__PURE__*/React.createElement(Facebook, null)), _defineProperty(_ContactInfoEnum$Call, ContactInfoEnum.Line, /*#__PURE__*/React.createElement(Line, null)), _ContactInfoEnum$Call)[buttonInfo.action];
      if (!icon) {
        return null;
      }
      return /*#__PURE__*/React.createElement(Button, {
        styles: {
          containerStyle: styles.firstButton
        },
        action: isCallOrEmail ? undefined : {
          func: ButtonEvents.OpenExternalLink,
          url_info: {
            url: buttonInfo.information
          }
        },
        trackingData: _objectSpread(_objectSpread({}, contactButton), {}, {
          trackingdataBasic: _objectSpread(_objectSpread({}, contactButton.trackingdataBasic), {}, {
            button_type: buttonInfo.action
          })
        })
      }, icon);
    } else {
      var _ContactInfoEnum$Call2, _ContactInfoEnum$Call3;
      var buttonContent = (_ContactInfoEnum$Call2 = {}, _defineProperty(_ContactInfoEnum$Call2, ContactInfoEnum.CallDriver, /*#__PURE__*/React.createElement(TouchableOpacity, {
        onPress: function onPress() {
          Linking.openURL("tel:".concat(buttonInfo.information));
        },
        style: styles.callOrEmailButton
      }, /*#__PURE__*/React.createElement(PhoneBlack, null), /*#__PURE__*/React.createElement(Text, {
        style: styles.popupButtonText
      }, trans(CONTACT_COURIER_CARD.CALL_DRIVER) || 'Call Driver'))), _defineProperty(_ContactInfoEnum$Call2, ContactInfoEnum.Call, /*#__PURE__*/React.createElement(TouchableOpacity, {
        onPress: function onPress() {
          handleInternetCall(function () {
            Linking.openURL("tel:".concat(buttonInfo.information));
          });
        },
        style: styles.callOrEmailButton
      }, /*#__PURE__*/React.createElement(PhoneBlack, null), /*#__PURE__*/React.createElement(Text, {
        style: styles.popupButtonText
      }, trans(CONTACT_COURIER_CARD.CALL)))), _defineProperty(_ContactInfoEnum$Call2, ContactInfoEnum.Email, /*#__PURE__*/React.createElement(TouchableOpacity, {
        onPress: function onPress() {
          Linking.openURL("mailto:".concat(buttonInfo.information));
        },
        style: styles.callOrEmailButton
      }, /*#__PURE__*/React.createElement(EmailBlack, null), /*#__PURE__*/React.createElement(Text, {
        style: styles.popupButtonText
      }, trans(CONTACT_COURIER_CARD.EMAIL)))), _defineProperty(_ContactInfoEnum$Call2, ContactInfoEnum.WhatsApp, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(WhatsappBlack, null), /*#__PURE__*/React.createElement(Text, {
        style: styles.popupButtonText
      }, trans(CONTACT_COURIER_CARD.WHATS_APP)))), _defineProperty(_ContactInfoEnum$Call2, ContactInfoEnum.Facebook, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FacebookBlack, null), /*#__PURE__*/React.createElement(Text, {
        style: styles.popupButtonText
      }, trans(CONTACT_COURIER_CARD.FACEBOOK)))), _defineProperty(_ContactInfoEnum$Call2, ContactInfoEnum.Line, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LineBlack, null), /*#__PURE__*/React.createElement(Text, {
        style: styles.popupButtonText
      }, trans(CONTACT_COURIER_CARD.LINE) || 'Line'))), _ContactInfoEnum$Call2)[buttonInfo.action];
      if (!buttonContent) {
        return null;
      }
      var buttonText = (_ContactInfoEnum$Call3 = {}, _defineProperty(_ContactInfoEnum$Call3, ContactInfoEnum.CallDriver, trans(CONTACT_COURIER_CARD.CALL_DRIVER) || 'Call Driver'), _defineProperty(_ContactInfoEnum$Call3, ContactInfoEnum.Call, trans(CONTACT_COURIER_CARD.CALL)), _defineProperty(_ContactInfoEnum$Call3, ContactInfoEnum.Email, trans(CONTACT_COURIER_CARD.EMAIL)), _defineProperty(_ContactInfoEnum$Call3, ContactInfoEnum.WhatsApp, trans(CONTACT_COURIER_CARD.WHATS_APP)), _defineProperty(_ContactInfoEnum$Call3, ContactInfoEnum.Facebook, trans(CONTACT_COURIER_CARD.FACEBOOK)), _defineProperty(_ContactInfoEnum$Call3, ContactInfoEnum.Line, trans(CONTACT_COURIER_CARD.LINE) || 'Line'), _ContactInfoEnum$Call3)[buttonInfo.action];
      return /*#__PURE__*/React.createElement(Button, {
        scope: CONTACT_COURIER_CARD_V2_SCOPE,
        styles: {
          containerStyle: styles.popupButton
        },
        action: isCallOrEmail ? undefined : {
          func: ButtonEvents.OpenExternalLink,
          url_info: {
            url: buttonInfo.information
          }
        },
        trackingData: _objectSpread(_objectSpread({}, popupButton), {}, {
          trackingdataBasic: _objectSpread(_objectSpread({}, popupButton.trackingdataBasic), {}, {
            button_text: buttonText,
            button_type: buttonInfo.action
          })
        })
      }, buttonContent);
    }
  };
  var renderFirstButton = function renderFirstButton() {
    return firstButton ? renderContactButton(firstButton, true) : null;
  };
  var showRestButton = showDriverCallButton && contactsInfo.length > 0 || !showDriverCallButton && contactsInfo.length > 1;
  var renderRestButton = function renderRestButton() {
    return showRestButton ? /*#__PURE__*/React.createElement(TouchableOpacity, {
      style: styles.restButton,
      onPress: function onPress() {
        return setIsContactPopupActive(true);
      }
    }, /*#__PURE__*/React.createElement(More, null)) : null;
  };
  var renderPopupButtons = function renderPopupButtons() {
    return restButtons.length > 0 ? restButtons.map(function (button, index) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, index !== 0 ? /*#__PURE__*/React.createElement(View, {
        style: {
          borderBottomWidth: 1,
          borderStyle: 'solid',
          borderBottomColor: 'rgba(0, 0, 0, 0.09)',
          transform: [{
            scaleY: getRealPx(1)
          }]
        }
      }) : null, renderContactButton(button, false));
    }) : null;
  };
  var contactCourier = replaceParams(trans(CONTACT_COURIER_CARD.CONTACT_COURIER) || 'Contact ${courier}', {
    courier: courierTitle
  });
  var contactTitle = "".concat(showDriverInfo && driverInfo !== null && driverInfo !== void 0 && driverInfo.driver_phone ? trans(CONTACT_COURIER_CARD.CONTACT_DRIVER) || 'Contact Driver' : contactCourier);
  useEffect(function () {
    var _dataMaintainer$track3;
    (_dataMaintainer$track3 = dataMaintainer.tracker) === null || _dataMaintainer$track3 === void 0 ? void 0 : _dataMaintainer$track3.dispatchTrack({
      operation: TRACKING_OPERATION.IMPRESSION,
      section: button.trackingsection,
      target: button.trackingtarget,
      data: {
        viewed_objects: expediteButtonTrackingData ? [trackButtonTrackingData, expediteButtonTrackingData] : [trackButtonTrackingData]
      }
    });
  }, []);
  useEffect(function () {
    if (isContactPopupActive) {
      setTimeout(function () {
        emitTrackingEvent(CONTACT_COURIER_CARD_V2_SCOPE);
      }, 0);
    }
  }, [isContactPopupActive]);
  return /*#__PURE__*/React.createElement(View, {
    style: styles.container
  }, /*#__PURE__*/React.createElement(View, {
    style: styles.parcelInfo
  }, orderInfo !== null && orderInfo !== void 0 && orderInfo.image ? /*#__PURE__*/React.createElement(Image, {
    styles: {
      containerStyle: styles.imageContainer,
      imageStyle: styles.image
    },
    width: 56,
    height: 56,
    src: cdnFile(orderInfo === null || orderInfo === void 0 ? void 0 : orderInfo.image, region)
  }) : null, /*#__PURE__*/React.createElement(View, {
    style: styles.mainInfo
  }, /*#__PURE__*/React.createElement(Text, {
    style: [styles.title, region === 'th' && styles.thTitle],
    numberOfLines: 1
  }, courierTitle), orderInfo !== null && orderInfo !== void 0 && orderInfo.shipping_trace_no ? /*#__PURE__*/React.createElement(View, {
    style: [styles.trackingNumberContainer, region === 'th' && styles.thTrackingNumberContainer]
  }, /*#__PURE__*/React.createElement(Text, {
    style: [styles.trackingNumberText, region === 'th' && styles.thTrackingNumberText],
    numberOfLines: 1
  }, orderInfo.shipping_trace_no), /*#__PURE__*/React.createElement(TouchableOpacity, {
    style: styles.copyButton,
    onPress: function onPress() {
      handleCopyClick === null || handleCopyClick === void 0 ? void 0 : handleCopyClick(orderInfo.shipping_trace_no);
    }
  }, /*#__PURE__*/React.createElement(Copy, null))) : null, /*#__PURE__*/React.createElement(Text, {
    style: [styles.status, region === 'th' && styles.thStatus],
    numberOfLines: 1
  }, trans((_driverInfo$milestone = driverInfo === null || driverInfo === void 0 ? void 0 : driverInfo.milestone_key) !== null && _driverInfo$milestone !== void 0 ? _driverInfo$milestone : ' ')))), /*#__PURE__*/React.createElement(View, {
    style: styles.trackAndExpedite
  }, /*#__PURE__*/React.createElement(TouchableOpacity, {
    style: styles.trackButton,
    onPress: function onPress() {
      handleTrack();
    }
  }, /*#__PURE__*/React.createElement(Text, {
    style: styles.trackButtonText,
    numberOfLines: 1
  }, trackButtonText)), showWebformButton ? /*#__PURE__*/React.createElement(TouchableOpacity, {
    style: [styles.expediteButton, isHistory && styles.expediteButtonDisabled],
    onPress: function onPress() {
      var _dataMaintainer$track4, _dataMaintainer$track5;
      if (!isHistory) {
        onWebformButtonClick === null || onWebformButtonClick === void 0 ? void 0 : onWebformButtonClick(webformButton);
      }
      (_dataMaintainer$track4 = dataMaintainer.tracker) === null || _dataMaintainer$track4 === void 0 ? void 0 : (_dataMaintainer$track5 = _dataMaintainer$track4.dispatchTrack) === null || _dataMaintainer$track5 === void 0 ? void 0 : _dataMaintainer$track5.call(_dataMaintainer$track4, {
        operation: TRACKING_OPERATION.CLICK,
        section: button.trackingsection,
        target: button.trackingtarget,
        data: expediteButtonTrackingData
      });
    }
  }, /*#__PURE__*/React.createElement(Text, {
    style: [styles.expediteButtonText, isHistory && styles.expediteButtonTextDisabled],
    numberOfLines: 1
  }, webformButton.button_text)) : null), firstButton ? /*#__PURE__*/React.createElement(View, {
    style: styles.contactPanel
  }, /*#__PURE__*/React.createElement(View, {
    style: styles.contactInfo
  }, /*#__PURE__*/React.createElement(Text, {
    style: [styles.contactTitle, region === 'th' && styles.thContactTitle]
  }, contactTitle), operateTime !== null && operateTime !== void 0 && operateTime.length ? /*#__PURE__*/React.createElement(View, {
    style: [styles.openingHoursContainer, region === 'th' && styles.thOpeningHoursContainer]
  }, /*#__PURE__*/React.createElement(Text, {
    style: [styles.openingHours, region === 'th' && styles.thOpeningHours],
    numberOfLines: 2
  }, operateTimeText)) : null), /*#__PURE__*/React.createElement(View, {
    style: styles.contactButtons
  }, renderFirstButton(), renderRestButton())) : null, /*#__PURE__*/React.createElement(Popup, {
    active: isLinkPopUpActive,
    onClose: function onClose() {
      return setIsLinkPopUpActive(false);
    },
    contentStyle: styles.linkPopup
  }, /*#__PURE__*/React.createElement(View, null, trackLinks.map(function (v, i) {
    return /*#__PURE__*/React.createElement(Button, {
      styles: {
        containerStyle: styles.linkButton
      },
      action: {
        func: ButtonEvents.Redirection,
        url_info: {
          url: v.url
        }
      },
      text: v.url,
      type: "link",
      key: i,
      numberOfLines: 1
    });
  }), /*#__PURE__*/React.createElement(View, {
    style: styles.linkPopupGap
  }), /*#__PURE__*/React.createElement(Text, {
    style: styles.linkCancelButton,
    onPress: function onPress() {
      return setIsLinkPopUpActive(false);
    }
  }, trans(CONTACT_COURIER_CARD.CANCEL) || 'Cancel'))), /*#__PURE__*/React.createElement(Popup, {
    title: contactCourier,
    active: isContactPopupActive,
    onClose: function onClose() {
      return setIsContactPopupActive(false);
    },
    showCloseIcon: true,
    contentStyle: styles.contactPopup,
    titleStyle: styles.contactPopupTitle,
    contentScrollable: false
  }, /*#__PURE__*/React.createElement(View, null, operateTime !== null && operateTime !== void 0 && operateTime.length ? /*#__PURE__*/React.createElement(View, {
    style: styles.popupOpeningHoursContainer
  }, /*#__PURE__*/React.createElement(View, {
    style: styles.popupOpeningHoursContent
  }, /*#__PURE__*/React.createElement(Text, {
    style: [styles.popupOpeningHours, region === 'th' && styles.thPopupOpeningHours]
  }, trans(CONTACT_COURIER_CARD.OPERATION_HOURS), ": ", operateTimeText))) : null, renderPopupButtons())));
};